var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorizationPendencies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 48,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20539_161914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2156 56.0104C49.2578 56.0104 54.1559 51.0933 54.1559 45.0279C54.1559 38.9624 49.2578 34.0454 43.2156 34.0454C37.1735 34.0454 32.2754 38.9624 32.2754 45.0279C32.2754 51.0933 37.1735 56.0104 43.2156 56.0104Z",
    stroke: "#F2873E",
    strokeWidth: 3.31083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2109 40.8984V45.0271L48.1094 47.2692",
    stroke: "#F2873E",
    strokeWidth: 3.31083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5381 8.23682V19.2192C29.5381 19.9474 29.8262 20.6458 30.3392 21.1607C30.8521 21.6756 31.5478 21.9648 32.2731 21.9648H43.2133",
    stroke: "#F2873E",
    strokeWidth: 3.31081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2134 28.0052V21.9648L29.5382 8.23682H18.598C17.1473 8.23682 15.7559 8.81535 14.7301 9.84515C13.7042 10.875 13.1279 12.2717 13.1279 13.728V41.184C13.1279 42.6404 13.7042 44.0371 14.7301 45.0669C15.7559 46.0967 17.1473 46.6753 18.598 46.6753H24.6151",
    stroke: "#F2873E",
    strokeWidth: 3.31081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20539_161914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 60.9524,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizationPendencies);
export default __webpack_public_path__ + "static/media/authorization-pendencies.682ad3f5.svg";
export { ForwardRef as ReactComponent };